// extracted by mini-css-extract-plugin
export default {"settings":"abortGame_settings__H-z44","settingsOpen":"abortGame_settingsOpen__bKDL1"};